import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ReportProblemComponent } from './report-problem/report-problem.component';
import { CanActivateGuard } from '../core/guards/can-activate.guard';
import { UploadImagesComponent } from './upload-images/upload-images.component';
import { ComplaintsListComponent } from './complaints-list/complaints-list.component';
import { ComplaintsDetailComponent } from './complaints-detail/complaints-detail.component';
import { MyComplaintComponent } from './my-complaint/my-complaint.component';
import { MyComplaintDetailComponent } from './my-complaint-detail/my-complaint-detail.component';
import { ComplaintDetailInappropriateComponent } from './complaint-detail-inappropriate/complaint-detail-inappropriate.component';
import { ComplaintsStatisticComponent } from './complaints-statistic/complaints-statistic.component';

const routes: Routes = [
    {
        path: 'report-problem',
        component: ReportProblemComponent,
        canActivate: [CanActivateGuard]
    },
    {
        path: 'upload-images/:complaintId',
        component: UploadImagesComponent
    },
    {
        path: 'all-complaints',
        component: ComplaintsListComponent
    },
    {
        path: 'complaint-detail/:id',
        component: ComplaintsDetailComponent
    },
    {
        path: 'my-complaints',
        component: MyComplaintComponent,
        canActivate: [CanActivateGuard]
    }
    ,
    {
        path: 'my-complaint-detail/:id',
        component: MyComplaintDetailComponent,
        canActivate: [CanActivateGuard]
    },
    {
        path: 'complaint-detail-inappropriate',
        component: ComplaintDetailInappropriateComponent
    },
    {
        path: 'statistic',
        component: ComplaintsStatisticComponent
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ComplaintsRoutingModule { }
